module.exports = __webpack_public_path__ + "media/images/aboutus/icon-mess-1212c33cc94dae498a03f09c0746b88c.svg";